import React, { useState } from 'react'
import { rankEntries, rankLabel } from './leaderboardRanks'
import { accent, textPrimary, borderDefault } from './styles'
import PlayerGameModal from './PlayerGameModal'
import { DAILY_CREDIT } from './gameLogic'

function Leaderboard({ data, playerName }) {
  const [selectedPlayer, setSelectedPlayer] = useState(null)

  if (!data || data.length === 0) {
    return (
      <div style={{ padding: '20px', textAlign: 'center', color: '#999' }}>
        <p>No entries yet</p>
      </div>
    )
  }

  return (
    <>
    <table
      style={{
        width: '100%',
        borderCollapse: 'collapse',
        fontSize: '0.9rem',
      }}
    >
      <thead>
        <tr style={{ borderBottom: `2px solid ${borderDefault}` }}>
          <th style={{ padding: '12px 8px', textAlign: 'left', fontWeight: '600', color: '#999', fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
            Rank
          </th>
          <th style={{ padding: '12px 8px', textAlign: 'left', fontWeight: '600', color: '#999', fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
            Name
          </th>
          <th style={{ padding: '12px 8px', textAlign: 'right', fontWeight: '600', color: '#999', fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
            Wager
          </th>
          <th style={{ padding: '12px 8px', textAlign: 'right', fontWeight: '600', color: '#999', fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
            Score
          </th>
          <th style={{ padding: '12px 8px', textAlign: 'right', fontWeight: '600', color: '#999', fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
            Payout
          </th>
          <th style={{ padding: '12px 8px', textAlign: 'right', fontWeight: '600', color: '#999', fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
            Banked Today
          </th>
        </tr>
      </thead>
      <tbody>
        {rankEntries(data, 'payout').map((entry, idx) => {
          const isCurrentPlayer = entry.player_name === playerName
          const payout = parseFloat(entry.payout) || 0
          return (
            <tr
              key={idx}
              onClick={() => setSelectedPlayer(entry)}
              style={{
                borderBottom: `1px solid ${borderDefault}`,
                backgroundColor: isCurrentPlayer ? '#f0faf0' : 'transparent',
                cursor: 'pointer',
                transition: 'background-color 0.15s ease',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = isCurrentPlayer ? '#e0f5e0' : '#f5f5f5'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = isCurrentPlayer ? '#f0faf0' : 'transparent'
              }}
            >
              <td aria-label={`${entry.tied ? 'Tied for rank' : 'Rank'} ${entry.rank}`} style={{ padding: '12px 8px', color: textPrimary, fontWeight: '600' }}>
                {rankLabel(entry)}
              </td>
              <td style={{ padding: '12px 8px', color: textPrimary }}>
                <span>{entry.player_name}</span>
                {isCurrentPlayer && (
                  <span
                    style={{
                      marginLeft: '8px',
                      fontSize: '0.7rem',
                      fontWeight: '600',
                      textTransform: 'uppercase',
                      letterSpacing: '0.06em',
                      color: accent,
                    }}
                  >
                    you
                  </span>
                )}
              </td>
              <td style={{ padding: '12px 8px', textAlign: 'right', color: '#666' }}>
                ${entry.wager ? parseFloat(entry.wager).toFixed(2) : '—'}
              </td>
              <td style={{ padding: '12px 8px', textAlign: 'right', color: '#666', fontWeight: '600' }}>
                {entry.accuracy}/4
              </td>
              <td style={{ padding: '12px 8px', textAlign: 'right', color: accent, fontWeight: '600' }}>
                {payout >= 0 ? '+' : ''}{payout.toFixed(2)}
              </td>
              <td style={{ padding: '12px 8px', textAlign: 'right', color: entry.banked_today === 'DNP' ? '#999' : '#15803d', fontWeight: '600' }}>
                {entry.banked_today === 'DNP' ? 'DNP' : `$${entry.banked_today ? parseFloat(entry.banked_today).toFixed(2) : (parseFloat(entry.payout || 0) + DAILY_CREDIT).toFixed(2)}`}
              </td>
            </tr>
          )
        })}
      </tbody>
    </table>

    {selectedPlayer && (
      <PlayerGameModal
        playerName={selectedPlayer.player_name}
        date={selectedPlayer.date}
        strikes={selectedPlayer.strikes}
        accuracy={selectedPlayer.accuracy}
        wager={selectedPlayer.wager}
        payout={selectedPlayer.payout}
        weeklyBank={selectedPlayer.weekly_bank}
        placedEventIds={selectedPlayer.placed_event_ids || []}
        onClose={() => setSelectedPlayer(null)}
      />
    )}
  </>
  )
}

export default Leaderboard
